type Stat = { number: string; unit: string; label: string };

const DEFAULT_STATS: Stat[] = [
  { number: "20–40", unit: "%", label: "KUR-Verbesserung · 12 Monate" },
  { number: "10–200", unit: "K€", label: "monatliche Ad-Budgets" },
  { number: "~80", unit: "%", label: "E-Commerce-Mandate" },
  { number: "+15–25", unit: "%", label: "Tracking-Recovery · Server-Side" },
];

export function StatsBlock({
  stats = DEFAULT_STATS,
  variant = "default",
}: {
  stats?: Stat[];
  variant?: "default" | "deep";
}) {
  const isDeep = variant === "deep";
  const valueColor = isDeep ? "text-lime" : "text-cyan-deep";
  const labelColor = isDeep ? "text-white/85" : "text-ink-4";
  const divider = isDeep ? "bg-white/10" : "bg-rule";
  const cardBg = isDeep ? "bg-transparent" : "bg-white";
  return (
    <div
      className={`grid grid-cols-2 gap-px overflow-hidden rounded-lg ${
        isDeep ? "border border-white/10" : "border border-rule"
      } ${divider} md:grid-cols-4`}
    >
      {stats.map((s) => (
        <div
          key={s.label}
          className={`${cardBg} flex flex-col items-start gap-1 px-6 py-8`}
        >
          <div
            className={`stat-number font-display whitespace-nowrap ${valueColor}`}
          >
            {s.number}
          </div>
          <div
            className={`stat-unit font-display whitespace-nowrap ${valueColor}`}
          >
            {s.unit}
          </div>
          <div
            className={`stat-label mt-2 font-mono uppercase ${labelColor}`}
            style={{ hyphens: "none", WebkitHyphens: "none", wordBreak: "keep-all" }}
          >
            {s.label}
          </div>
        </div>
      ))}
    </div>
  );
}
